var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "view-action-form",
      attrs: { hide: _vm.loading },
    },
    [
      _c(
        "ui-heading",
        { attrs: { title: _vm.pageTitle } },
        [
          _c(
            "ui-button",
            {
              attrs: { color: "positive", loading: _vm.submitting },
              on: {
                click: function ($event) {
                  return _vm.$refs.form.submit()
                },
              },
            },
            [_vm._v("Opslaan")]
          ),
          _c(
            "ui-button",
            {
              attrs: {
                slot: "left",
                color: "medium",
                type: "bordered",
                to: _vm.backRoute,
              },
              slot: "left",
            },
            [_vm._v("Annuleren")]
          ),
        ],
        1
      ),
      _c(
        "ui-form-panel",
        {
          ref: "form",
          attrs: { "auto-validate": "" },
          on: { submit: _vm.submit },
        },
        [
          _c("ui-form-date-input", {
            attrs: { title: "Datum", name: "date", rules: "required" },
            model: {
              value: _vm.pendingSample.date,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSample, "date", $$v)
              },
              expression: "pendingSample.date",
            },
          }),
          _c("ui-form-input", {
            attrs: { number: "", title: "Bustal", name: "bustal" },
            model: {
              value: _vm.pendingSample.bustal,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSample, "bustal", $$v)
              },
              expression: "pendingSample.bustal",
            },
          }),
          _c("ui-form-input", {
            attrs: { number: "", title: "Stukstal", name: "stukstal" },
            model: {
              value: _vm.pendingSample.stukstal,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSample, "stukstal", $$v)
              },
              expression: "pendingSample.stukstal",
            },
          }),
          _c("ui-form-textarea", {
            attrs: { title: "Bijzonderheden", name: "notes" },
            model: {
              value: _vm.pendingSample.notes,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSample, "notes", $$v)
              },
              expression: "pendingSample.notes",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }